import { Tooltip } from "antd";
import { DeleteOutlined, QuestionCircleTwoTone } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Popconfirm from "../../../antd/pop-confirm";
import Button, { ButtonProps } from "../../../antd/button";
import { StrictMode } from "react";
import { TooltipPlacement } from "antd/es/tooltip";

interface Props extends ButtonProps {
  onConfirm: () => void;
  placement?: TooltipPlacement;
}

const DeleteBtn: React.FC<Props> = ({ onConfirm, ...props }) => {
  const { t } = useTranslation();

  return (
    <Popconfirm
      title={t("confirmDelete")}
      placement={props.placement}
      okButtonProps={{ danger: true, loading: props.loading }}
      icon={<QuestionCircleTwoTone twoToneColor="red" />}
      onConfirm={onConfirm}
    >
      <Tooltip title={t("delete")}>
        <Button
          type="primary"
          danger
          shape="circle"
          icon={<DeleteOutlined />}
          {...props}
        />
      </Tooltip>
    </Popconfirm>
  );
};

export default DeleteBtn;
